.changelog-item .status .pulse-container {
  width: 12px;
  overflow: hidden;
  position: relative;
}
.changelog-item .status .pulse-container .pulse {
  position: absolute;
  top: 3px;
  width: 12px;
  height: 12px;
}
.changelog-item .status .published {
  margin-left: 8px;
}
.changelog-item .status.is-hidden .pulse-container {
  width: 0;
}
.changelog-item .status.is-hidden .published {
  margin-left: 2px;
  transition: all 0.3s linear;
}
.changelog-item .changelog-item-description figure {
  margin-bottom: 20px;
}
.changelog-item .changelog-item-description figure img {
  border-radius: 8px;
}
.changelog-item .changelog-item-description p {
  font-size: 14px;
  line-height: 24px;
  color: #3d3d3d;
  padding-bottom: 15px;
}
.changelog-item .changelog-item-description p a {
  text-decoration: underline;
}
